import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a267354a&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style1 from "./index.vue?vue&type=style&index=1&id=a267354a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a267354a",
  null
  
)

export default component.exports